import { Injectable } from '@angular/core';
import {
    EnvironmentDiff,
    EnvironmentDiffModified,
} from '../components/questionnaire/configit-quest-adapter/configit-types.interface';

export interface Scheme {
    primary: string[];
    secondary: string[];
    ems: string[];
}

interface EnvironmentDiffCache {
    hybridPackage: string;
    optionalCategories: string[];
}

@Injectable({
    providedIn: 'root',
})
export class EnvironmentDiffService {
    private cache: EnvironmentDiffCache = {
        hybridPackage: '',
        optionalCategories: [],
    };
    constructor() {}

    public clearCache() {
        this.cache = { hybridPackage: '', optionalCategories: [] };
    }

    public getCurrentSchemes(environmentDiff: EnvironmentDiff): Scheme {
        const keys = ['SCHEME-PDF-PRIMARY', 'SCHEME-PDF-SECONDARY', 'EMS-SCHEME'];
        if (keys.some((key) => !!environmentDiff?.added[key])) {
            const [primary, secondary, ems] = keys.map((key) => (environmentDiff.added[key] || '').split(';'));
            return { primary, secondary, ems };
        }
        if (keys.some((key) => !!environmentDiff?.modified[key])) {
            const [primary, secondary, ems] = keys.map((key) => environmentDiff.modified[key]);
            return { primary, secondary, ems };
        }
        return undefined;
    }

    public updateCache(environmentDiff: EnvironmentDiff) {
        this.cache.optionalCategories = this.getOptionalCategories(environmentDiff);
        this.cache.hybridPackage = this.getHybridPackage(environmentDiff);
    }

    public getOptionalCategoriesFromCache(): string[] {
        return this.cache.optionalCategories;
    }

    public getHybridPackageFromCache() {
        return this.cache.hybridPackage;
    }

    public getCurrentSampleOfferId(environmentDiff: EnvironmentDiff): string {
        if (environmentDiff?.added['SAMPLE-OFFER-ID']) {
            return environmentDiff.added['SAMPLE-OFFER-ID'];
        }
        if (environmentDiff?.modified['SAMPLE-OFFER-ID']) {
            return this.getModified(environmentDiff.modified['SAMPLE-OFFER-ID'])[0];
        }
        return '';
    }

    private getHybridPackage(environmentDiff: EnvironmentDiff) {
        if (environmentDiff?.added['HYBRID-PACKAGE']) {
            return environmentDiff.added['HYBRID-PACKAGE'];
        }
        if (environmentDiff?.modified['HYBRID-PACKAGE']) {
            return this.getModified(environmentDiff.modified['HYBRID-PACKAGE']);
        }
    }

    private getOptionalCategories(environmentDiff: EnvironmentDiff): string[] {
        if (environmentDiff?.added['OPTIONAL-CATEGORIES']) {
            return environmentDiff.added['OPTIONAL-CATEGORIES'].split(';');
        }
        if (environmentDiff?.modified['OPTIONAL-CATEGORIES']) {
            return this.getModified(environmentDiff.modified['OPTIONAL-CATEGORIES']);
        }
        return [];
    }

    private getModified(modified: EnvironmentDiffModified) {
        if (modified?.added?.length) {
            return modified.added.map((added) => added.value.split(';')).reduce((prev, curr) => prev.concat(curr), []);
        }
        if (modified?.removed?.length) {
            return [];
        }
        return undefined;
    }
}
